export const PROMO_STORAGE_KEY = "promotionClosed";
